export default "__VITE_ASSET__b5r9tfibBQMA3F$txRJfHg__"